export interface EditorSite {
  role: string;
  site_key: number;
  site_name: string;
  site_url: string;
  category_key: number | null;
}

export const editorSites: EditorSite[] = [
  {
    role: 'clemson_sports_editor',
    site_key: 9,
    site_name: 'Clemson',
    site_url: '/teams/clemson-tigers',
    category_key: 77,
  },
  {
    role: 'ksr_editor',
    site_key: 24,
    site_name: 'KSR',
    site_url: '/teams/kentucky-wildcats',
    category_key: 76,
  },
  {
    role: 'lettermen_row_editor',
    site_key: 25,
    site_name: 'Lettermen Row',
    site_url: '/teams/ohio-state-buckeyes',
    category_key: 75,
  },
  {
    role: 'alabama_editor',
    site_key: 72,
    site_name: 'BamaOnLine',
    site_url: '/teams/alabama-crimson-tide',
    category_key: 123,
  },
  {
    role: 'insidetexas_editor',
    site_key: 73,
    site_name: 'Inside Texas',
    site_url: '/teams/texas-longhorns',
    category_key: 98,
  },
  {
    role: 'dawgshq_editor',
    site_key: 74,
    site_name: 'DawgsHQ',
    site_url: '/teams/georgia-bulldogs',
    category_key: 103,
  },
  {
    role: 'scoop_duck_editor',
    site_key: 75,
    site_name: 'Scoop Duck',
    site_url: '/teams/oregon-ducks',
    category_key: 108,
  },
  {
    role: 'auburn_editor',
    site_key: 76,
    site_name: 'AuburnSports',
    site_url: '/teams/auburn-tigers',
    category_key: 113,
  },
  {
    role: 'wearesc_editor',
    site_key: 79,
    site_name: 'WeAreSC',
    site_url: '/teams/usc-trojans',
    category_key: 6651,
  },
  {
    role: 'michigan_editor',
    site_key: 80,
    site_name: 'The Wolverine',
    site_url: '/teams/michigan-wolverines',
    category_key: 9406,
  },
  {
    role: 'penn_state_editor',
    site_key: 81,
    site_name: 'BWI',
    site_url: '/teams/penn-state-nittany-lions',
    category_key: 9400,
  },
  {
    role: 'nc_state_editor',
    site_key: 82,
    site_name: 'The Wolfpacker',
    site_url: '/teams/nc-state-wolfpack',
    category_key: 9382,
  },
  {
    role: 'florida_editor',
    site_key: 83,
    site_name: 'GatorsOnline',
    site_url: '/teams/florida-gators',
    category_key: 118,
  },
  {
    role: 'ole_miss_editor',
    site_key: 362,
    site_name: 'Rebel Grove',
    site_url: '/teams/ole-miss-rebels',
    category_key: 63912,
  },
  {
    role: 'notre_dame_editor',
    site_key: 363,
    site_name: 'Blue and Gold',
    site_url: '/teams/notre-dame-fighting-irish',
    category_key: 65756,
  },
  {
    role: 'lsu_editor',
    site_key: 364,
    site_name: 'The Bengal Tiger',
    site_url: '/teams/lsu-tigers',
    category_key: 72262,
  },
  {
    role: 'smu_editor',
    site_key: 365,
    site_name: 'On The Pony Express',
    site_url: '/teams/smu-mustangs',
    category_key: 89507,
  },
  {
    role: 'south_carolina_editor',
    site_key: 366,
    site_name: 'GamecockCentral',
    site_url: '/teams/south-carolina-gamecocks',
    category_key: 89512,
  },
  {
    role: 'texas_am_editor',
    site_key: 367,
    site_name: 'Texas A&M Aggies',
    site_url: '/teams/texas-am-aggies',
    category_key: 89532,
  },
  {
    role: 'nebraska_editor',
    site_key: 370,
    site_name: 'HuskerOnline',
    site_url: '/teams/nebraska-cornhuskers',
    category_key: 89546,
  },
  {
    role: 'miami_editor',
    site_key: 371,
    site_name: 'CaneSport',
    site_url: '/teams/miami-hurricanes',
    category_key: 89551,
  },
  {
    role: 'fsu_editor',
    site_key: 372,
    site_name: 'Warchant',
    site_url: '/teams/florida-state-seminoles',
    category_key: 89561,
  },
  {
    role: 'tennessee_editor',
    site_key: 373,
    site_name: 'Volquest',
    site_url: '/teams/tennessee-volunteers',
    category_key: 89566,
  },
  {
    role: 'kansas_state_editor',
    site_key: 374,
    site_name: 'K-State Online',
    site_url: '/teams/kansas-state-wildcats',
    category_key: 89571,
  },
  {
    role: 'mississippi_state_editor',
    site_key: 376,
    site_name: 'Maroon and White',
    site_url: '/teams/mississippi-state-bulldogs',
    category_key: 138460,
  },
  {
    role: 'purdue_editor',
    site_key: 377,
    site_name: 'Gold and Black',
    site_url: '/teams/purdue-boilermakers',
    category_key: 89576,
  },
  {
    role: 'michigan_state_editor',
    site_key: 382,
    site_name: 'SpartanMag',
    site_url: '/teams/michigan-state-spartans',
    category_key: 138792,
  },
  {
    role: 'iowa_editor',
    site_key: 383,
    site_name: 'Hawkeye Report',
    site_url: '/teams/iowa-hawkeyes',
    category_key: 139316,
  },
  {
    role: 'ksr_editor',
    site_key: 395,
    site_name: 'KSR+',
    site_url: '/sites/kentucky-wildcats',
    category_key: 282066,
  },
  {
    role: 'oklahoma_editor',
    site_key: 396,
    site_name: 'Sooner Scoop',
    site_url: '/teams/oklahoma-sooners',
    category_key: 538300,
  },
  {
    role: 'softball_america_editor',
    site_key: 401,
    site_name: 'Softball America',
    site_url: '/softball',
    category_key: 552031,
  },
  {
    role: 'indiana_editor',
    site_key: 408,
    site_name: 'TheHoosier',
    site_url: '/teams/indiana-hoosiers',
    category_key: 570127,
  },
  {
    role: 'asu_devils_editor',
    site_key: 412,
    site_name: 'ASU Devils',
    site_url: '/sites/asu-devils',
    category_key: 580929,
  },
  {
    role: 'hawg_beat_editor',
    site_key: 415,
    site_name: 'HawgBeat',
    site_url: '/sites/hawg-beat',
    category_key: 580945,
  },
  {
    role: 'go_black_knights_editor',
    site_key: 416,
    site_name: 'Go Black Knights',
    site_url: '/sites/go-black-knights',
    category_key: 580966,
  },
  {
    role: 'eagle_action_editor',
    site_key: 417,
    site_name: 'Eagle Action',
    site_url: '/sites/eagle-action',
    category_key: 580971,
  },
  {
    role: 'golden_bear_report_editor',
    site_key: 418,
    site_name: 'Golden Bear Report',
    site_url: '/sites/golden-bear-report',
    category_key: 580976,
  },
  {
    role: 'tiger_illustrated_editor',
    site_key: 419,
    site_name: 'Tiger Illustrated',
    site_url: '/sites/tiger-illustrated',
    category_key: 580985,
  },
  {
    role: 'cu_sports_report_editor',
    site_key: 420,
    site_name: 'CU Sports Report',
    site_url: '/sites/cu-sports-report',
    category_key: 580989,
  },
  {
    role: 'devils_illustrated_editor',
    site_key: 421,
    site_name: 'Devils Illustrated',
    site_url: '/sites/devils-illustrated',
    category_key: 580994,
  },
  {
    role: 'jackets_online_editor',
    site_key: 422,
    site_name: 'Jackets Online',
    site_url: '/sites/jackets-online',
    category_key: 580999,
  },
  {
    role: 'orange_and_blue_news_editor',
    site_key: 423,
    site_name: 'Orange & Blue News',
    site_url: '/sites/orange-blue-news',
    category_key: 581004,
  },
  {
    role: 'cyclone_report_editor',
    site_key: 424,
    site_name: 'Cyclone Report',
    site_url: '/sites/cyclone-report',
    category_key: 581009,
  },
  {
    role: 'jayhawk_slant_editor',
    site_key: 425,
    site_name: 'Jayhawk Slant',
    site_url: '/sites/jayhawk-slant',
    category_key: 581014,
  },
  {
    role: 'bleed_tech_blue_editor',
    site_key: 426,
    site_name: 'Bleed Tech Blue',
    site_url: '/sites/bleed-tech-blue',
    category_key: 581019,
  },
  {
    role: 'cardinal_sports_editor',
    site_key: 427,
    site_name: 'Cardinal Sports',
    site_url: '/sites/cardinal-sports',
    category_key: 581024,
  },
  {
    role: 'terrapin_sports_report_editor',
    site_key: 428,
    site_name: 'Terrapin Sports Report',
    site_url: '/sites/terrapin-sports-report',
    category_key: 581029,
  },
  {
    role: 'gophers_nation_editor',
    site_key: 429,
    site_name: 'Gophers Nation',
    site_url: '/sites/gophers-nation',
    category_key: 581034,
  },
  {
    role: 'mizzou_today_editor',
    site_key: 430,
    site_name: 'MizzouToday',
    site_url: '/sites/mizzou-today',
    category_key: 581039,
  },
  {
    role: 'the_mid_report_editor',
    site_key: 431,
    site_name: 'The Mid Report',
    site_url: '/sites/the-mid-report',
    category_key: 581044,
  },
  {
    role: 'tar_heel_illustrated_editor',
    site_key: 432,
    site_name: 'Inside Carolina',
    site_url: '/teams/north-carolina-tar-heels',
    category_key: 581789,
  },
  {
    role: 'wildcat_report_editor',
    site_key: 433,
    site_name: 'Wildcat Report',
    site_url: '/sites/wildcat-report',
    category_key: 581054,
  },
  {
    role: 'o_state_illustrated_editor',
    site_key: 434,
    site_name: 'OState Illustrated',
    site_url: '/sites/o-state-illustrated',
    category_key: 581059,
  },
  {
    role: 'beavers_edge_editor',
    site_key: 435,
    site_name: 'BeaversEdge',
    site_url: '/sites/beavers-edge',
    category_key: 581064,
  },
  {
    role: 'pitt_sports_news_editor',
    site_key: 436,
    site_name: 'Pitt Sports News',
    site_url: '/sites/pitt-sports-news',
    category_key: 581069,
  },
  {
    role: 'the_knight_report_editor',
    site_key: 437,
    site_name: 'The Knight Report',
    site_url: '/sites/the-knight-report',
    category_key: 581074,
  },
  {
    role: 'pirate_crew_editor',
    site_key: 438,
    site_name: 'Pirate Crew',
    site_url: '/sites/pirate-crew',
    category_key: 581079,
  },
  {
    role: 'bulls_insider_editor',
    site_key: 439,
    site_name: 'Bulls Insider',
    site_url: '/sites/bulls-insider',
    category_key: 581085,
  },
  {
    role: 'big_gold_nation_editor',
    site_key: 440,
    site_name: 'Big Gold Nation',
    site_url: '/sites/big-gold-nation',
    category_key: 581090,
  },
  {
    role: 'cardinal_sports_report_editor',
    site_key: 441,
    site_name: 'Cardinal Sports Report',
    site_url: '/sites/cardinal-sports-report',
    category_key: 581095,
  },
  {
    role: 'owl_scoop_editor',
    site_key: 442,
    site_name: 'OwlScoop',
    site_url: '/sites/owl-scoop',
    category_key: 581100,
  },
  {
    role: 'aggie_yell_editor',
    site_key: 443,
    site_name: 'Aggie Yell',
    site_url: '/sites/aggie-yell',
    category_key: 581105,
  },
  {
    role: 'red_raider_sports_editor',
    site_key: 444,
    site_name: 'Red Raider Sports',
    site_url: '/sites/red-raider-sports',
    category_key: 581110,
  },
  {
    role: 'inside_tulsa_sports_editor',
    site_key: 445,
    site_name: 'Inside Tulsa Sports',
    site_url: '/sites/inside-tulsa-sports',
    category_key: 581115,
  },
  {
    role: 'ucf_sports_editor',
    site_key: 446,
    site_name: 'UCF Sports',
    site_url: '/sites/ucf-sports',
    category_key: 581120,
  },
  {
    role: 'bruin_blitz_editor',
    site_key: 447,
    site_name: 'Bruin Blitz',
    site_url: '/sites/bruin-blitz',
    category_key: 581125,
  },
  {
    role: 'the_dore_report_editor',
    site_key: 448,
    site_name: 'The DORE Report',
    site_url: '/sites/the-dore-report',
    category_key: 581130,
  },
  {
    role: 'cavs_corner_editor',
    site_key: 449,
    site_name: 'CavsCorner',
    site_url: '/sites/cavs-corner',
    category_key: null,
  },
  {
    role: 'deacons_illustrated_editor',
    site_key: 450,
    site_name: 'Deacons Illustrated',
    site_url: '/sites/deacons-illustrated',
    category_key: 581141,
  },
  {
    role: 'wv_sports_editor',
    site_key: 451,
    site_name: 'WV Sports',
    site_url: '/sites/wv-sports',
    category_key: 581148,
  },
  {
    role: 'badger_blitz_editor',
    site_key: 452,
    site_name: 'Badger Blitz',
    site_url: '/sites/badger-blitz',
    category_key: 581158,
  },
  {
    role: 'uga_sports_editor',
    site_key: 453,
    site_name: 'UGASports',
    site_url: '/sites/uga-sports',
    category_key: 581163,
  },
  {
    role: 'cats_illustrated_editor',
    site_key: 454,
    site_name: 'Cats Illustrated',
    site_url: '/sites/cats-illustrated',
    category_key: 581168,
  },
  {
    role: 'maize_blue_review_editor',
    site_key: 455,
    site_name: 'Maize & Blue Review',
    site_url: '/sites/maize-blue-review',
    category_key: 581173,
  },
  {
    role: 'spartans_illustrated_editor',
    site_key: 456,
    site_name: 'Spartans Illustrated',
    site_url: '/sites/spartans-illustrated',
    category_key: 581415,
  },
  {
    role: 'inside_nebraska_editor',
    site_key: 457,
    site_name: 'Inside Nebraska',
    site_url: '/sites/inside-nebraska',
    category_key: null,
  },
  {
    role: 'ou_insider_editor',
    site_key: 458,
    site_name: 'OUInsider',
    site_url: '/sites/ou-insider',
    category_key: null,
  },
  {
    role: 'alabama_varsity_editor',
    site_key: 459,
    site_name: 'Alabama HS',
    site_url: '/sites/alabama-varsity',
    category_key: null,
  },
  {
    role: 'arizona_varsity_editor',
    site_key: 460,
    site_name: 'Arizona Varsity',
    site_url: '/sites/arizona-varsity',
    category_key: null,
  },
  {
    role: 'colorado_prep_report_editor',
    site_key: 461,
    site_name: 'Colorado Prep Report',
    site_url: '/sites/colorado-prep-report',
    category_key: null,
  },
  {
    role: 'fla_varsity_editor',
    site_key: 462,
    site_name: 'FLA Varsity',
    site_url: '/sites/fla-varsity',
    category_key: null,
  },
  {
    role: 'ga_varsity_editor',
    site_key: 463,
    site_name: 'GA Varsity',
    site_url: '/sites/ga-varsity',
    category_key: null,
  },
  {
    role: 'edgy_tim_editor',
    site_key: 464,
    site_name: 'Edgy Tim',
    site_url: '/sites/edgy-tim',
    category_key: 581219,
  },
  {
    role: 'hickory_husker_editor',
    site_key: 465,
    site_name: 'Hickory Husker',
    site_url: '/sites/hickory-husker',
    category_key: 581222,
  },
  {
    role: 'iowa_preps_editor',
    site_key: 466,
    site_name: 'Iowa Preps',
    site_url: '/sites/iowa-preps',
    category_key: 581225,
  },
  {
    role: 'maryland_varsity_editor',
    site_key: 467,
    site_name: 'Maryland Varsity',
    site_url: '/sites/maryland-varsity',
    category_key: 581228,
  },
  {
    role: 'huskerland_preps_editor',
    site_key: 468,
    site_name: 'Huskerland Preps',
    site_url: '/sites/huskerland-preps',
    category_key: 581231,
  },
  {
    role: 'nj_hoops_editor',
    site_key: 469,
    site_name: 'NJ Hoops',
    site_url: '/sites/nj-hoops',
    category_key: 581234,
  },
  {
    role: 'nm_preps_editor',
    site_key: 470,
    site_name: 'NM Preps',
    site_url: '/sites/nm-preps',
    category_key: 581236,
  },
  {
    role: 'nyc_hoops_editor',
    site_key: 471,
    site_name: 'NYC Hoops',
    site_url: '/sites/nyc-hoops',
    category_key: 581240,
  },
  {
    role: 'nor_cal_preps_editor',
    site_key: 472,
    site_name: 'NorCalPreps',
    site_url: '/sites/nor-cal-preps',
    category_key: 581242,
  },
  {
    role: 'nc_preps_editor',
    site_key: 473,
    site_name: 'NC Preps',
    site_url: '/sites/nc-preps',
    category_key: 581245,
  },
  {
    role: 'ohio_preps_editor',
    site_key: 474,
    site_name: 'Ohio Preps',
    site_url: '/sites/ohio-preps',
    category_key: 581248,
  },
  {
    role: 'pa_preps_editor',
    site_key: 475,
    site_name: 'PA Preps',
    site_url: '/sites/pa-preps',
    category_key: 581251,
  },
  {
    role: 'tn_varsity_editor',
    site_key: 476,
    site_name: 'TN Varsity',
    site_url: '/sites/tn-varsity',
    category_key: 581255,
  },
  {
    role: 'lone_star_preps_editor',
    site_key: 477,
    site_name: 'Lone Star Preps',
    site_url: '/sites/lone-star-preps',
    category_key: 581258,
  },
  {
    role: 'virginia_preps_editor',
    site_key: 478,
    site_name: 'VirginiaPreps',
    site_url: '/sites/virginia-preps',
    category_key: 581261,
  },
  {
    role: 'washington_preps_editor',
    site_key: 479,
    site_name: 'Washington Preps',
    site_url: '/sites/washington-preps',
    category_key: 581264,
  },
  {
    role: 'tiger_sports_report_editor',
    site_key: 480,
    site_name: 'Tiger Sports Report',
    site_url: '/sites/tiger-sports-report',
    category_key: 581766,
  },
  {
    role: 'warhawk_report_editor',
    site_key: 481,
    site_name: 'Warhawk Report',
    site_url: '/sites/warhawk-report',
    category_key: 581774,
  },
  {
    role: 'uconn_report_editor',
    site_key: 485,
    site_name: 'Uconn Report',
    site_url: '/sites/uconn-report',
    category_key: 582290,
  },
  {
    role: 'ute_nation_editor',
    site_key: 486,
    site_name: 'UteSports',
    site_url: '/sites/ute-nation',
    category_key: null,
  },
  {
    role: 'jcgridiron_editor',
    site_key: 487,
    site_name: 'JCGridiron',
    site_url: '/sites/jcgridiron',
    category_key: 582660,
  },
];
